import * as React from 'react'
import { Box } from '@ally/metronome-ui'
import { AdobeTile } from '../../../types'
import AdobeIcon from '../AdobeIcon'
import CtaLink from '../CtaLink'

interface ComponentProps {
  tileData: AdobeTile
}

const LgTile: React.FC<ComponentProps> = ({ tileData }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      justifyItems="flex-start"
      width="100%"
    >
      <AdobeIcon tileData={tileData} />
      <Box size="md" color="slate-5">
        {tileData.description}
      </Box>
      <CtaLink tileData={tileData} />
    </Box>
  )
}

export default LgTile
